import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import stepThreeIllustration from '/public/SiteImages/step3.svg';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';
import updateStep3 from './updateStep3';
import validateStep3 from './validateStep3';

class Title extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      chars_left: 50,
      showMinWarning: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.renderTitleInput = this.renderTitleInput.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  componentDidMount() {
    const { title } = this.props;
    let max_chars = title ? 50 - title.length : 50;
    this.setState({
      chars_left: max_chars,
      showMinWarning: title ? (title.length > 0 && title.length < 10) : false
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    const { title } = nextProps;
    let max_chars = title ? 50 - title.length : 50;
    this.setState({
      chars_left: max_chars,
      showMinWarning: title ? (title.length > 0 && title.length < 10) : false
    });
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  handleChange(event) {
    var input = event.target.value;
    let max_chars = 50;
    this.setState({
      chars_left: max_chars - input.length,
      showMinWarning: input.length > 0 && input.length < 10
    });
  }

  renderTitleInput({ input, placeholder, maxLength }) {
    return (
      <textarea
        {...input}
        placeholder={placeholder}
        maxLength={maxLength}
        className={s.titleTextareaField}
        rows={2}
        onChange={(e) => {
          input.onChange(e);
          this.handleChange(e);
        }}
      />
    );
  }

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step, existingList, title } = this.props;
    const { isDisabled } = this.state;

    let path = "index";
    if (existingList) {
      path = "home";
    }

    const currentCount = title ? title.length : 0;

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`Ahora, vamos a ponerle título \n`}
            highlightText="a tu espacio"
            subtitle={`Un buen título ayuda a que tu anuncio \n destaque y atraiga más reservas`}
            iconImg={stepThreeIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={cx(s.stepRightCard, s.titleStepCard)}>
              <div className={s.landingMainContent}>
                {/* Header: Icon + Title + Subtitle */}
                <div className={s.titleHeaderRow}>
                  <div className={s.titleHeaderIcon}>
                    <img src="/SiteIcons/etiqueta.svg" width="70" height="70" />

                  </div>
                  <div className={s.titleHeaderText}>
                    <h2 className={s.titleMainHeading}>Título de tu espacio</h2>
                    <p className={s.titleSubHeading}>
                      Usa un título corto, claro y atractivo que resuma lo mejor de tu alojamiento. Esto ayudará a que más huéspedes lo encuentren.
                    </p>
                  </div>
                </div>

                {/* Input Card */}
                <div className={s.titleInputContainer}>
                  <Field
                    name="title"
                    component={this.renderTitleInput}
                    placeholder="Ej. Apartamento moderno con vista al lago"
                    maxLength={50}
                  />
                  <div className={s.titleCharCounterNew}>
                    {currentCount}/50
                  </div>
                </div>

                {/* Tips Box */}
                <div className={s.titleTipsCard}>
                  <div className={s.titleTipsHeader}>
                    <div className={s.titleTipsIcon}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0084FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 2C12 7.5 7.5 12 2 12C7.5 12 12 16.5 12 22C12 16.5 16.5 12 22 12C16.5 12 12 7.5 12 2Z" />
                        <path d="M19 2C19 3.5 17.5 5 16 5C17.5 5 19 6.5 19 8C19 6.5 20.5 5 22 5C20.5 5 19 3.5 19 2Z" fill="#0084FF" stroke="none" />
                      </svg>
                    </div>
                    <span className={s.titleTipsTitle}>Consejos para un buen título:</span>
                  </div>

                  <ul className={s.titleTipsList}>
                    <li className={s.titleTipsItem}>
                      <div className={s.titleTipsCheck}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <circle cx="10" cy="10" r="10" fill="#0084FF" />
                          <path d="M6 10.2L8.7 13L14 7.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      <span className={s.titleTipsText}>
                        Sé específico sobre el tipo de alojamiento (casa, departamento, cabaña, etc.)
                      </span>
                    </li>

                    <li className={s.titleTipsItem}>
                      <div className={s.titleTipsCheck}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <circle cx="10" cy="10" r="10" fill="#0084FF" />
                          <path d="M6 10.2L8.7 13L14 7.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      <span className={s.titleTipsText}>
                        Destaca lo más especial (ubicación, vista, estilo, amenidades)
                      </span>
                    </li>

                    <li className={s.titleTipsItem}>
                      <div className={s.titleTipsCheck}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <circle cx="10" cy="10" r="10" fill="#0084FF" />
                          <path d="M6 10.2L8.7 13L14 7.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      <span className={s.titleTipsText}>
                        Manténlo corto y claro (máximo 50 caracteres)
                      </span>
                    </li>

                    <li className={s.titleTipsItem}>
                      <div className={s.titleTipsCheck}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <circle cx="10" cy="10" r="10" fill="#0084FF" />
                          <path d="M6 10.2L8.7 13L14 7.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                      <span className={s.titleTipsText}>
                        Evita palabras genéricas como “hermoso” o “increíble” sin un detalle concreto
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              <FooterButton
                isDisabled={isDisabled}
                nextPage={nextPage}
                previousPage={previousPage}
                previousPagePath={path}
                nextPagePath={"description"}
                formPage={formPage}
                step={step}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

Title = reduxForm({
  form: 'ListPlaceStep3',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Title);

const selector = formValueSelector('ListPlaceStep3');

const mapState = (state) => ({
  existingList: state.location.isExistingList,
  listingFields: state.listingFields.data,
  title: selector(state, 'title'),
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Title)));
